import React from "react";
import { Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import defaultProfilePic from "../../../assets/Images/avtarPic.png";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import Switch from "@mui/material/Switch";
// import FormControlLabel from "@mui/material/FormControlLabel";
import SearchIcon from "@mui/icons-material/Search";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import swal from "sweetalert";
import moment from "moment";

import { makePostRequest } from "../../../utils/utils";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// const label = { inputProps: { "aria-label": "Switch demo" } };

function InOutLogs() {
  // const navigate = useNavigate();

  const [, setValue] = React.useState(dayjs(dayjs(new Date())));
  const [q] = React.useState("");
  const [date, setDate] = React.useState(dayjs(new Date()));
  const [Upload, setUpload] = React.useState(true);


  const handleChange = (newValue) => {
    setValue(newValue);
    setDate(newValue);
    setUpload(!Upload);
    getAllActiveServiceProviders();
  };

  const [selected, setSelected] = React.useState(false);

  const [activeServiceProviders, setActiveServiceProvidersList] =
    React.useState([]);
 
  async function getAllActiveServiceProviders() {
    setActiveServiceProvidersList([]);
    const inputData={
      date: date
    }
    await makePostRequest(
      "serviceProvider/GetServiceProviderInOutListing",inputData
       
    )
      .then((response) => {
        console.log("Active Service Providers List ", response);
        if (response.data.status == "1") {
          const data = response.data.data;
          setActiveServiceProvidersList(response.data.data.rows);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  React.useEffect(() => {
    getAllActiveServiceProviders();
  }, [q,Upload]);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Service Providers In/Out Logs</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Service Providers In/Out Logs</div>

            <div className="addAgencyMain">
              <div className="addServiceTypeMain">
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <div className="visitorSearch">
                      <div className="visitorSearchDiv">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search"
                          //   onChangeCapture={(e) => setQ(e.target.value)}
                        />
                        {/* <MicIcon className="visitorMicIco" /> */}
                      </div>
                      <div className="sortingIcoOut">
                        <ToggleButton
                          value="check"
                          selected={selected}
                          onChange={() => {
                            setSelected(!selected);
                          }}
                        >
                          <ImportExportIcon
                            className="visitorFilterIco"
                            // aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            // aria-expanded={open ? "true" : undefined}
                            // onClick={(e) => handleChangeSortBy(e, "Tenent")}
                          />
                        </ToggleButton>
                      </div>
                      <div className="forCurAssiggnDrop">
                        <select className="inputSt">
                          <option>Service Type's</option>
                        </select>
                      </div>
                      <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            className="inputStDateMain"
                            inputFormat="MM/DD/YYYY"
                            value={date}
                            onChange={handleChange}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>

                    {activeServiceProviders.length > 0 ? (
                      <>
                        {activeServiceProviders.map((option) => (
                          <div className="visitContDiv ">
                            <div className="visitCont1 resideNewContOut">
                              <div className="visitContProf">
                                {option.profile_pic ? (
                                  <img src={option.profile_pic} />
                                ) : (
                                  <img src={defaultProfilePic} />
                                )}
                              </div>
                              <div className="visitContLeft">
                                <h3 className="visitContHed">
                                  {option.firstname} {option.lastname}
                                </h3>
                                <p className="visitContMob">
                                  {option.contactno}
                                </p>
                              </div>
                              <div className="visitBottCont">
                                <p>Service Type</p>
                                <b>{option.service_type}</b>
                              </div>
                              <div className="visitBottCont">
                                <p>In Time & Date</p>
                                <b>
                                  {moment
                                    .utc(option.start_date)
                                    .format("DD-MM-YYYY")}
                                  ,{" "}
                                  <b style={{ color: "#18c018" }}>
                                    {" "}
                                    {moment
                                      .utc(option.start_time)
                                      .format("hh mm a")}
                                  </b>
                                </b>
                              </div>

                              <div className="visitBottCont">
                                <p>Out Time & Date</p>
                                <b>
                                  {moment
                                    .utc(option.end_date)
                                    .format("DD-MM-YYYY")}
                                  ,{" "}
                                  <b style={{ color: "red" }}>
                                    {" "}
                                    {moment
                                      .utc(option.end_time)
                                      .format("hh mm a")}
                                  </b>
                                </b>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <>No Active Service Providers</>
                    )}
                  </Grid>
                  <div className="listPaginationMain">
                    <Stack spacing={2}>
                      <Pagination
                        count={10}
                        variant="outlined"
                        shape="rounded"
                      />
                    </Stack>
                  </div>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default InOutLogs;
